import { useLocale } from "next-intl";
import Link from "next/link";
import { useAppContext } from "../appContext";

interface HeaderProps {
  translations?: { en: string; cs: string };
  mobile?: boolean;
}

function LanguageSwitch({ translations, mobile }: HeaderProps) {
  const locale = useLocale();
  const { toggleMenu } = useAppContext();
  const targetSlug = locale === "cs" ? translations?.en : translations?.cs;
  const currentSlug = locale === "cs" ? translations?.cs : translations?.en;

  if (!targetSlug && currentSlug) {
    return null;
  }

  return (
    <div
      className={`p-1  rounded border-neutral-200 border border-neutral-200 mono overflow-hidden ${mobile ? "bg-white" : "bg-neutral-100"}`}
    >
      <Link
        href={
          locale === "cs"
            ? `/en/${targetSlug ?? ""}`
            : `/cs/${targetSlug ?? ""}`
        }
        className="flex relative group"
        hrefLang={locale === "cs" ? "en" : "cs"}
      >
        <div
          className={`${locale === "en" ? "left-[0%] group-hover:left-1/2" : "left-[50%] group-hover:left-0"} rounded-sm pointer-events-none absolute bg-neutral-900/10 bg-neutral-200 h-full w-1/2 transition-all top-0`}
        />
        <span
          className="z-2 relative group flex items-center justify-center p-2 min-w-[40px] min-h-[40px]"
        >
          EN
        </span>

        <span
          className="flex items-center justify-center group p-2 z-2 relative min-w-[40px] min-h-[40px]"
        >
          CS
        </span>
      </Link>
    </div>
  );
}
export default LanguageSwitch;
